export interface BobNudgeConfig {
  category: string;
  imageUrl: string;
  triggerEvent?: string;
}

export const BOB_NUDGES_CONFIG: BobNudgeConfig[] = [
  {
    category: 'UPCOMING_EMI_REMINDER',
    imageUrl: '/bob/nudges/reduce_your_loan_burden.jpg',
  },
  {
    category: 'UPCOMING_EMI_BUT_NOT_ENOUGH_BALANCE',
    imageUrl: '/bob/nudges/simplify_your_repayments.jpg',
  },
  {
    category: 'NEW_EMI_DETECTED',
    imageUrl: '/bob/nudges/simplify_your_repayments.jpg',
  },
  {
    category: 'GOLD_LOAN_QUICK_CASH_NEED',
    imageUrl: '/bob/nudges/get_funds_when_you_need_them.jpg',
  },
  {
    category: 'SUGGEST_INSURANCE',
    imageUrl: '/bob/nudges/protect_what_matters.jpg',
  },
  {
    category: 'SUGGEST_MUTUAL_FUND',
    imageUrl: '/bob/nudges/start_your_investment_journey.jpg',
  },
  {
    category: 'STOPPED_SIP_INVESTMENT',
    imageUrl: '/bob/nudges/get_bank_on_track.jpg',
  },
  {
    category: 'SUGGEST_FIXED_DEPOSIT',
    imageUrl: '/bob/nudges/grow_your_savings_safely.jpg',
  },
  {
    category: 'SUGGEST_RECURRING_DEPOSIT',
    imageUrl: '/bob/nudges/build_saving_habit.jpg',
  },
  {
    category: 'SUGGEST_DEMAT_ACCOUNT',
    imageUrl: '/bob/nudges/start_your_stock_journey.jpg',
  },
  {
    category: 'SURPLUS_BALANCE_IN_ACCOUNT',
    imageUrl: '/bob/nudges/make_your_money_grow.jpg',
  },
  {
    category: 'TRAVEL_DETECTED_FLIGHT',
    imageUrl: '/bob/nudges/travel_smarter.jpg',
  },
  {
    category: 'TRAVEL_DETECTED_TRAIN',
    imageUrl: '/bob/nudges/plan_your_journey_easily.jpg',
  },
  {
    category: 'TRAVEL_DETECTED_BUS',
    imageUrl: '/bob/nudges/travel_made_simple.jpg',
  },
  {
    category: 'TRAVEL_DETECTED_HOTEL',
    imageUrl: '/bob/nudges/stay_better_for_less.jpg',
  },
  {
    category: 'SUGGEST_CREDIT_CARD_C',
    triggerEvent: 'SUGGEST_CREDIT_CARD',
    imageUrl: '/bob/nudges/upgrade_your_spending_experience.jpg',
  },
  {
    category: 'SUGGEST_CREDIT_CARD_R',
    triggerEvent: 'SUGGEST_CREDIT_CARD',
    imageUrl: '/bob/nudges/make_every_payment_rewarding.jpg',
  },
  {
    category: 'HEALTH_INSURANCE_MEDICAL_SPEND',
    imageUrl: '/bob/nudges/be_ready_for_medical_needs.jpg',
  },
];

/** Quick lookup: category → image URL (first matching entry) */
export const NUDGE_ENUM_IMAGE_MAP: Record<string, string> = BOB_NUDGES_CONFIG.reduce(
  (acc, cfg) => {
    if (!acc[cfg.category]) {
      acc[cfg.category] = cfg.imageUrl;
    }
    return acc;
  },
  {} as Record<string, string>
);
